export default __webpack_public_path__ + "static/media/img.691798d3.png";